export default "__VITE_ASSET__VfeCRj4h__"